import Swiper, { Navigation, Pagination } from 'swiper'

const SwiperGallery = function () {

  // configure Swiper to use modules
  Swiper.use(Navigation, Pagination);
  const els = document.querySelectorAll( '.gallery-swiper' )

  // loop through swiper sections and init Swiper
  if ( Object.keys(els).length ) {
    els.forEach( function( el ){
      const nextButton = el.querySelector( '.swiper-button-next');
      const prevButton = el.querySelector( '.swiper-button-prev');
      const pagination = el.querySelector( '.swiper-pagination');

      const swiper = new Swiper( el , {
        direction: 'horizontal',
        spaceBetween: 15,
        slidesPerView: 'auto',
        centeredSlides: true,
        initialSlide: 0,
        loop: true,
        preventClicks: true,
        pagination: {
          el: pagination,
          clickable: true
        },
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton
        },
        breakpoints: {
          992: {
            allowTouchMove: false,
            slidesPerView: 4
          }
        }
      })
    });
  }

  // Overflow issues
  let browserWidth = $(window).width();
  if ( browserWidth < 992 ) {
    $('.gallery-modal').on('show.bs.modal', function () {
      const scrollY = window.scrollY + "px";
      document.body.style.top = `-${scrollY}`;
      setTimeout(() => {
        document.body.style.position = 'fixed';
      }, 300);
    });
      

    $('.gallery-modal').on('hidden.bs.modal', function () {
      const scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      document.documentElement.style = "scroll-behavior: auto";
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
      window.addEventListener('scroll', () => {
        document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
      });
    });
  }
}

export default SwiperGallery;
